










































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { UpgradeJob, UpgradeJobType } from '@/types/upgradejob';
import { UpgradeReportType } from '@/types/upgradereporttype';
import { upgradeJobTabs } from '@/types/upgradejobtabs';

@Component({
  name: 'akk-mapping-job-form',
  props: {
    lastThreeCycles: Array,
    akkMappingReportHistory: Array,
    currentlySelectedFiId: Number,
    noAkkMappingReportHistory: Array,
    jobOnThisTabRunning: Boolean,
  },
})
export default class AkkMappingJobForm extends Vue {
	UpgradeReportType = UpgradeReportType;

	upgradeJobTabs = upgradeJobTabs

	cycleData:Object = {};

	selectedCycleStatementEnd:string = '';

	ddaSuffixToStrip:string = '';

	savSuffixToStrip:string = '';

	krpDivider:string = '';

	gen2Divider:string = '';

	krpSuffixWidth:string = '';

	gen2SuffixWidth:string = '';

	isJobOnThisTabRunning() {
	  return this.$props.jobOnThisTabRunning;
	}

	emitRunUpgradeJob() {
	  this.$emit('runSelectedUpgradeJob', UpgradeJobType.AKK,
	  	AkkMappingJobForm.getRunReportUrl(), this.getRunReportRequestBody());
	}

	getRunReportRequestBody() {
    	return {
	    fiId: this.$props.currentlySelectedFiId,
		    ddaSuffixToStrip: this.ddaSuffixToStrip,
    		savSuffixToStrip: this.savSuffixToStrip,
    		gen2AccountSuffixWidth: this.gen2SuffixWidth,
    		gen2AccountDivider: this.gen2Divider,
	    krpAccountSuffixWidth: this.krpSuffixWidth,
	    krpAccountDivider: this.krpDivider,
	    processingDate: this.selectedCycleStatementEnd,
	  };
	}

	static getRunReportUrl() {
	  return '/api/krp/admin/upgrade/akk';
	}

	mounted() {
	  this.updateCycleData();
	}

	@Watch('lastThreeCycles')
	updateCycleData() {
	  this.cycleData = this.$props.lastThreeCycles;
	}

	areNoReportsForSelectedFi() {
	  return 	this.$props.akkMappingReportHistory
				&& this.$props.noAkkMappingReportHistory
				&& this.$props.akkMappingReportHistory.length === 0
				&& this.$props.noAkkMappingReportHistory.length === 0;
	}

	areAkkMappingReportsLoaded() {
	  return this.$props.akkMappingReportHistory
			&& this.$props.akkMappingReportHistory.length !== 0;
	}

	areNoAkkMappingReportsLoaded() {
	  return this.$props.noAkkMappingReportHistory
			&& this.$props.noAkkMappingReportHistory.length !== 0;
	}

	shouldDisableRunReportButton() {
	  return this.selectedCycleStatementEnd.length === 0;
	}

	emitDownloadReport(reportType:UpgradeReportType, s3Key:string, versionId:string) {
	  this.$emit('downloadPreviousReportVersion', reportType, s3Key, versionId);
	}
}
